import { toastShown } from './feedbackSlice';
import { TOAST_TONE } from './feedbackConstants';

const make = (tone) => (message, options = {}) => toastShown({ ...options, tone, message });

/**
 * Action creators for a toast, for what does not go through a thunk with a rule
 * in `feedbackCatalog`: a copy to the clipboard, a blocked popup, a merged PDF.
 *
 * `dispatch(notify.success('Webhook creado', { testId: 'webhooks-notice' }))`
 *
 * Options: `title`, `testId`, `action` (`{label, type, to|url}`, see
 * `TOAST_ACTION`), `sticky`, `progress`, `dedupeKey`, `id`.
 */
export const notify = {
  success: make(TOAST_TONE.SUCCESS),
  info: make(TOAST_TONE.INFO),
  warning: make(TOAST_TONE.WARNING),
  error: make(TOAST_TONE.ERROR),
  progress: make(TOAST_TONE.PROGRESS),
};
